import { fetch } from '@maxtropy/components';
import { PageRequest, PageResponse } from './page';
import { CircuitType } from './circuit';
export interface NextCircuitPageReq extends PageRequest {
  circuitId?: string;
}
export interface NextCircuitPageProps {
  circuitId?: number;
  circuitCode?: string;
  circuitName?: string;
  circuitType?: CircuitType;
  distributionCabinetName?: string;
  positiveActivePowerConfig?: boolean;
  reverseActivePowerConfig?: boolean;
}
// 查询下级回路列表
export const getNextCircuitPage = (query: NextCircuitPageReq) =>
  fetch<PageResponse<NextCircuitPageProps>>(
    `/api/v2/circuit-line-loss/page`,
    {
      method: 'POST',
      body: JSON.stringify(query),
    },
    true
  );

// 查询回路下拉列表
export const getNextCircuitOptions = (id: string) =>
  fetch<{ list: NextCircuitPageProps[] }>(
    `/api/v2/circuit-line-loss/list`,
    {
      method: 'POST',
      body: JSON.stringify({ id }),
    },
    true
  );

// 创建回路线损配置
export interface createCircuitLossReq {
  computationalLogic?: number;
  circuitId?: number | string;
  computationalTime?: any;
  downstreamCircuitIds?: (number | string)[];
}
export const createCircuitLoss = (params: createCircuitLossReq) =>
  fetch<{ status: boolean }>(
    `/api/v2/circuit-line-loss/create`,
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
// 修改回路线损配置
export const updateCircuitLoss = (params: createCircuitLossReq) =>
  fetch<{ status: boolean }>(
    `/api/v2/circuit-line-loss/update`,
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
// 删除回路线损配置
export const deleteCircuitLoss = (id: string | number) =>
  fetch<{ status: boolean }>(
    `/api/v2/circuit-line-loss/delete`,
    {
      method: 'POST',
      body: JSON.stringify({ id }),
    },
    true
  );

// 查询回路线损配置详情
export interface CircuitLossRes {
  circuitId?: number;
  circuitName?: string;
  circuitConfig?: boolean;
  circuitType?: CircuitType;
  downstreamCircuitCount?: number;
  downstreamCircuitConfig?: boolean;
  computationalTime?: any;
  computationalLogic?: number;
}
export const getCircuitLossDetail = (id: string) =>
  fetch<CircuitLossRes>(
    `/api/v2/circuit-line-loss/detail`,
    {
      method: 'POST',
      body: JSON.stringify({ id }),
    },
    true
  );

// 线损报警记录
export interface LossAlarmLogsReq extends PageRequest {
  ouIds?: number[] | string[];
  circuitName?: string;
  alarmStartTime?: any;
  alarmEndTime?: any;
}
export interface LossAlarmLogsRes {
  id?: number;
  circuitId?: number;
  circuitName?: string;
  ruleId?: number;
  ruleCode?: string;
  ruleName?: string;
  lossElectricity?: number;
  lossRate?: number;
  circuitChildrenElectricity?: number;
  circuitTotalElectricity?: number;
  alarmTime?: any;
  circuitCode?: string;
  interval?: string;
  ruleDelete?: boolean;
}
export const getLossAlarmLogDetail = (id: any) =>
  fetch<LossAlarmLogsRes>(
    `/api/v2/line-loss/alarm/log/detail`,
    {
      method: 'POST',
      body: JSON.stringify({ id }),
    },
    true
  );

// 线损报警规则列表0-禁用，1-启用，2-删除
export enum AlarmRuleStatus {
  DISBALE,
  ENABLE,
  DELETE,
}
export const formateAlarmRuleStatus = {
  [AlarmRuleStatus.DISBALE]: '禁用',
  [AlarmRuleStatus.ENABLE]: '启用',
  [AlarmRuleStatus.DELETE]: '删除',
};
export interface LossAlarmRulesReq extends PageRequest {
  ouId?: number | string;
  ruleName?: string;
  circuitName?: string;
  status?: AlarmRuleStatus;
}
export interface LossAlarmRulesRes {
  id?: number;
  circuitId?: number;
  circuitIdList?: number[];
  circuitName?: string;
  ruleId?: number;
  code?: string;
  circuitDeleted?: boolean;
  alarmLogic?: number;
  name?: string;
  ouName?: string;
  ouId?: number;
  status?: number;
  cycle?: number;
  loss?: number;
  lossRate?: number;
  createTime?: any;
  updateTime?: any;
  updateByUserId?: string;
  updateByUsername?: string;
}
export const getLossAlarmRulePage = (query: LossAlarmRulesReq) =>
  fetch<PageResponse<LossAlarmRulesRes>>(
    `/api/v2/line-loss/alarm/rule/page`,
    {
      method: 'POST',
      body: JSON.stringify(query),
    },
    true
  );

// 更新线损报警规则状态/启用/禁用/删除状态
export const changeAlarmRuleStatus = (id: any, status: AlarmRuleStatus) =>
  fetch(
    `/api/v2/line-loss/alarm/rule/status`,
    {
      method: 'POST',
      body: JSON.stringify({ id, status }),
    },
    true
  );
